export const returnLabel = (labelArray = [], key) => {
    return labelArray.find((x) => x.Key === key)?.Phrase || "";
};

export const getClientSubAccountCmsFetchers = (refClientAccountCmsData) => {
    const getLabelByComponent = (componentKey, key) => {
        const labels = refClientAccountCmsData?.Components?.[componentKey]?.Labels;
        return returnLabel(labels, key);
    };

    return {
        fetchClientSubAccountCmsData: (key) =>
            getLabelByComponent("ClientSubAccountDetails.SetupClientSubAccount", key),
        fetchClientTeamMemberCmsData: (key) =>
            getLabelByComponent("ClientAccounts.ClientTeamMembers", key),
        fetchAccountTeamMemberCmsData: (key) =>
            getLabelByComponent("ClientAccounts.AccountTeamMembers", key),
        fetchAccountAdminCmsData: (key) =>
            getLabelByComponent("ClientAccounts.AccountAdmins", key),
    };
};
